module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reservation-survey-configuration"
  }, _vm._l((_vm.value), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column shrink delete"
    }, [_c('DeleteConf', {
      on: {
        "click": function($event) {
          return _vm.value.splice(index, 1)
        }
      }
    })], 1), _vm._l((elem), function(val, inx) {
      return _c('div', {
        staticClass: "column"
      }, [(inx === 'reporting_type_id') ? _c('label', [_vm._v(_vm._s(inx)), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index].reporting_type_id),
          expression: "value[index].reporting_type_id"
        }],
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.value[index], "reporting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("--")]), _vm._l((_vm.reportingTypes), function(type) {
        return _c('option', {
          domProps: {
            "value": type.id
          }
        }, [_vm._v(_vm._s(type.name))])
      })], 2)]) : (inx === 'rating_threshold') ? _c('label', [_vm._v(_vm._s(inx)), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        attrs: {
          "type": "number",
          "min": "1",
          "max": "5"
        },
        domProps: {
          "value": (_vm.value[index][inx])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.value[index], inx, $event.target.value)
          }
        }
      })]) : (inx === 'mandatory') ? _c('div', {
        staticClass: "mandatory"
      }, [_c('label', [_vm._v(_vm._s(inx))]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index].mandatory),
          expression: "value[index].mandatory"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(_vm.value[index].mandatory) ? _vm._i(_vm.value[index].mandatory, null) > -1 : (_vm.value[index].mandatory)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.value[index].mandatory,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.value[index], "mandatory", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.value[index], "mandatory", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.value[index], "mandatory", $$c)
            }
          }
        }
      })]) : _c('label', [_vm._v(_vm._s(inx)), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (_vm.value[index][inx])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.value[index], inx, $event.target.value)
          }
        }
      })])])
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d2c9680!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/ReservationSurveyConfiguration.vue
// module id = 2371
// module chunks = 1